var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-good-table',{staticClass:"cargo-details mb-50",attrs:{"styleClass":"vgt-table bordered","theme":"polar-bear","columns":_vm.columns,"rows":_vm.rows,"group-options":{
        enabled: true
    },"search-options":{
        enabled: true,
        externalQuery: _vm.searchTerm
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }